import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Página no encontrada | UTPL</title>
        <meta
          name="description"
          content="La página que buscas no existe."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <main className="min-h-[60vh] flex items-center justify-center px-6">
        <div className="text-center my-24">
          <h1 className="text-8xl font-bold text-[#004270]">
            404
          </h1>

          <h2 className="mt-4 text-2xl font-semibold">
            Página no encontrada
          </h2>

          <p className="mt-3 text-gray-600">
            La página que buscas no existe o ya no está disponible.
          </p>

          <Link
            to="/"
            className="inline-block mt-6 px-6 py-3 rounded-lg bg-[#004270] text-white"
          >
            Ir al inicio
          </Link>
        </div>
      </main>
    </>
  );
};

export default NotFound;